import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../Logo";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/how-it-works", label: "How It Works" },
  { to: "/about", label: "About" },
  { to: "/demo", label: "View Demo" },
];

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-xl border-b border-border">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-link"><Logo size={34} /></Link>
        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/ /g, "-")}-link`}
              className="px-4 py-2 text-sm text-slatey hover:text-ink transition-colors rounded-full">
              {l.label}
            </Link>
          ))}
          <Button variant="ghost" className="rounded-full text-ink" onClick={() => nav("/signin")} data-testid="nav-signin-btn">Sign In</Button>
          <Button className="rounded-full bg-navy hover:bg-navy-light text-white" onClick={() => nav("/register")} data-testid="nav-signup-btn">
            Sign Up Free
          </Button>
        </nav>
        <button className="md:hidden text-ink" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-border bg-background px-5 py-4 space-y-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className="block px-2 py-2.5 text-slatey">{l.label}</Link>
          ))}
          <div className="flex gap-2 pt-2">
            <Button variant="secondary" className="rounded-full flex-1" onClick={() => nav("/signin")}>Sign In</Button>
            <Button className="rounded-full flex-1 bg-navy text-white" onClick={() => nav("/register")}>Sign Up</Button>
          </div>
        </div>
      )}
    </header>
  );
}
